import {useMemo} from 'react'
import {useReviewSummaries, useThreads} from '../../../../stores/layout-selectors'
import {assignThreadsToReviews} from './collect-review-comments'

export function useReviews() {
  const reviewSummaries = useReviewSummaries()
  const threads = useThreads()

  // `reviewSummaries`/`threads` are stable references from the layout store, so this only recomputes when the
  // underlying review data actually changes rather than on every render.
  return useMemo(() => assignThreadsToReviews(reviewSummaries, threads), [reviewSummaries, threads])
}
